<script>
export default {
    data() {
        return {
            form: {
                status: '',
                name_keyword: '',
            }
        };
    },
    methods: {
        onSubmit() {
            this.$emit('search');
        },
        getValue() {
            const v = Object.assign({}, this.form);
            if (!v.status) {
                delete v.status;
            }
            if (!v.name_keyword) {
                delete v.name_keyword;
            }
            return v;
        }
    }
};
</script>
<template>
    <el-form :inline="true" size="mini" :model="form" class="demo-form-inline">
        <el-form-item :label="$tt('版本号')">
            <el-input v-model="form.name_keyword" clearable :placeholder="$tt('搜索历史版本')" />
        </el-form-item>
        <el-form-item :label="$tt('状态')">
            <el-select v-model="form.status" clearable :placeholder="$tt('请选择')">
            <el-option :label="$tt('启用')" value="true"></el-option>
            <el-option :label="$tt('停用')" value="false"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">{{ $tt("查询") }}</el-button>
        </el-form-item>
    </el-form>
</template>
